import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { AuthProvider } from './AuthContext.jsx'
import { ActivationProvider } from './ActivationContext.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AuthProvider>
      <ActivationProvider>
        <App />
      </ActivationProvider>
    </AuthProvider>
  </StrictMode>,
)
